import React, { useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Mail, MapPin, Phone, Loader2 } from "lucide-react";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", subject: "General", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post(`/contact`, form);
      toast.success(data.message);
      setForm({ name: "", email: "", subject: "General", message: "" });
    } catch {
      toast.error("Could not submit. Please try again.");
    } finally { setLoading(false); }
  };

  const change = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div data-testid="contact-page" className="max-w-6xl mx-auto px-6 lg:px-10 py-12 grid lg:grid-cols-2 gap-14">
      <div>
        <p className="text-xs uppercase tracking-widest text-welljio-subtle mb-3">Contact</p>
        <h1 className="font-heading text-5xl font-bold tracking-tight mb-6">We're here for your wellness journey.</h1>
        <p className="text-welljio-muted leading-relaxed mb-10">Reach out with product questions, recovery guidance or partnership ideas. Our team responds within 24 hours.</p>
        <ul className="space-y-4 text-welljio-ink">
          <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-welljio-accent" strokeWidth={1.5}/> support@welljio.com</li>
          <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-welljio-accent" strokeWidth={1.5}/> +91 80 4567 8910</li>
          <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-welljio-accent" strokeWidth={1.5}/> Hyderabad, India</li>
        </ul>
      </div>
      <form onSubmit={submit} className="bg-white border border-slate-100 rounded-3xl p-8 space-y-4" data-testid="contact-form">
        <input required value={form.name} onChange={change("name")} placeholder="Your name" data-testid="contact-name" className="w-full border border-slate-200 rounded-2xl px-5 py-3.5 outline-none focus:border-welljio-accent text-sm"/>
        <input required type="email" value={form.email} onChange={change("email")} placeholder="Email" data-testid="contact-email" className="w-full border border-slate-200 rounded-2xl px-5 py-3.5 outline-none focus:border-welljio-accent text-sm"/>
        <select value={form.subject} onChange={change("subject")} data-testid="contact-subject" className="w-full border border-slate-200 rounded-2xl px-5 py-3.5 outline-none focus:border-welljio-accent text-sm bg-white">
          <option>General</option>
          <option>Product question</option>
          <option>Order support</option>
          <option>Partnership</option>
        </select>
        <textarea required value={form.message} onChange={change("message")} placeholder="Message" rows={5} data-testid="contact-message" className="w-full border border-slate-200 rounded-2xl px-5 py-3.5 outline-none focus:border-welljio-accent text-sm"/>
        <button disabled={loading} type="submit" data-testid="contact-submit-button" className="w-full bg-welljio-ink text-white rounded-full py-4 font-medium hover:bg-slate-800 transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
          {loading ? <><Loader2 className="w-4 h-4 animate-spin"/> Sending...</> : "Send message"}
        </button>
      </form>
    </div>
  );
}
